"use client";

import Flex from "@/components/core/flex";
import Text from "@/components/shared/text";
import { cn } from "@/lib/utils/utils";
import { LucideIcon } from "lucide-react";
import { IconType } from "react-icons/lib";
interface HeaderItemProps {
  icon?: LucideIcon | IconType;
  title: string;
  item: string | React.ReactNode;
  iconSize?: number;
  iconClassName?: string;
  titleClassName?: string;
  itemClassName?: string;
}

export default function HeaderItem({
  icon: Icon,
  title,
  item,
  iconSize = 28,
  iconClassName,
  titleClassName,
  itemClassName,
}: HeaderItemProps) {
  return (
    <article className="flex flex-row gap-4 items-center">
      {Icon && (
        <div className={iconClassName}>
          <Icon size={iconSize} />
        </div>
      )}
      <Flex direction="col" justify="center">
        <Text className={cn("text-primary", titleClassName)}>{title}</Text>
        <Text as="span" color="secondary" className={cn(itemClassName)} bdi>
          {item}
        </Text>
      </Flex>
    </article>
  );
}
